import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faTwitter, faGooglePlay, faWhatsapp, faTelegram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Argon from './plugins/argon-kit'
import { ImagePlugin, CardPlugin, LayoutPlugin, FormSelectPlugin, FormPlugin, FormCheckboxPlugin } from 'bootstrap-vue'

library.add(faEnvelope, faAngleLeft, faAngleRight, faFacebookSquare, faTwitter, faGooglePlay, faWhatsapp, faTelegram)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = true
Vue.use(Argon)
Vue.use(ImagePlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormPlugin)
Vue.use(FormCheckboxPlugin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
